import React, { Component } from 'react'
import { connect } from 'react-redux'

import General from '../components/ContratoAnual/General'
import Documentos from '../components/ContratoAnual/Documentos'
import Cancelacion from '../components/ContratoAnual/Cancelacion'
import ModalAddFirmas from '../components/ContratoAnual/ModalAddFirmas'

import BoxButton from '../components/Layout/BoxButton'
import ButtonStrip from '../components/Layout/ButtonStrip'
import ModalConfirmarAccion from '../components/Shared/ModalConfirmarAccion'

import { showModalConfirmarAccion } from '../actions/common'


import { 
    canmbiarResponsable
} from '../actions/common'



import history from '../utils/history'

import { getSolicitud, cancelSolicitud } from '../actions/contratoanual'

class ContratoAnual extends Component {
	constructor(props) {
		super(props)
		this.state = {
			tabs: [
                { id: 0, caption: 'Solicitud', component: <General />, estado: 0 },
                { id: 1, caption: 'Documentos', component: <Documentos />, estado: 1 },
                { id: 2, caption: 'Rechazar', component: <Cancelacion />, estado: 0 },
			],
			selected: 0
		}
    }

    componentWillMount() {
        if (this.props.match.params.id) {
            this.props.getSolicitud(this.props.match.params.id)
        } else {
            history.push(window.FOLDER + '/solicitudes')
        }
    }

	selectTab = (e, tab) => {
		e.preventDefault()
		this.setState({ selected: tab })
    }
    
    cancel = () => {
        this.props.showModalConfirmarAccion(true, `¿Está seguro que desea rechazar esta solicitud?`, () => { this.props.showModalConfirmarAccion(false); this.props.cancelSolicitud()})
    }


	render() {
        
		const { tabs, selected } = this.state
        const { estado, btnRComprasDisabled, solicitud } = this.props

        const boxActions = [
            <BoxButton key="ba[0][0]" name="floppy-o" onClick={ () => this.cancel() } title="Rechazar solicitud" disabled={ (estado > 4 || estado === 0) || selected !== 2 } />,
            <BoxButton key="ba[0][1]" name="user" onClick={ () => this.props.canmbiarResponsable(solicitud, 'ACTUALIZAR_SOLICITUD_CONTRATOANUAL') } title="Cambiar responsable" disabled={ btnRComprasDisabled || selected !== 0 } />,
        ]


		return (
            <div className="row" style={{ height: '100%', overflowX: 'hidden' }}>
                <div className="col-md-12" style={{ height: '100%' }}>
                    <div className="nav-container">
                        <div className="nav-tabs-section">
                            <ul className="nav-tabs-tabs">
                                {
                                    tabs.filter(x => x.estado <= estado).map(x => {
                                        
                                        //if ((estado == 0) && (x.id == 1)) return null
                                        //if ((estado == 7) && (x.id == 2)) return null
                                        if ((estado > 4) && (x.id == 2)) return null

                                        return (
                                            <li key={ `li01[${x.id}]` } className={ selected === x.id ? 'active' : '' }>
                                                <a onClick={ (e) => this.selectTab(e, x.id) }>{ x.caption }</a>
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        </div>
                        <div className="nav-main-section">
                            <div className="">
                                <ButtonStrip actions={ boxActions } />
                            </div>
                            <div className="nav-main-section-scrollable">
                                { tabs[selected].component }
                            </div>
                        </div>
                    </div>
                </div>

                <ModalAddFirmas/>
                <ModalConfirmarAccion />

                

            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        estado: state.contratoanual.get('estado'),
        btnRComprasDisabled: state.contratoanual.get('btnRComprasDisabled'),
        solicitud: state.contratoanual.get('solicitud'),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getSolicitud: (id) => dispatch(getSolicitud(id)),
        cancelSolicitud: () => dispatch(cancelSolicitud()),
        showModalConfirmarAccion: (show, message, action) => dispatch(showModalConfirmarAccion(show, message, action)),
        canmbiarResponsable: (solicitud, type) => dispatch(canmbiarResponsable(solicitud, type)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContratoAnual)


// WEBPACK FOOTER //
// ./src/containers/ContratoAnual.jsx